exports = module.exports = require("../../../../math-wordproblems/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fraction{line-height:1.1}.fraction .cross-reduction{color:#24b5ba}.fraction .pgcd-reduction{color:#2154e9}", ""]);

// exports
